import { monthData, staffOptions } from "./data";

export const getOptionLabel = (role) => {
  const found = staffOptions.find((v) => v?.value == role);
  return found ? found.label : "";
};

export const getPaidMonthLabel = (month, year) => {
  const found = monthData.find((v) => v?.id == month);
  return found ? `${found.label} - ${year}` : "";
};

export const getPaymentMode = (mode)=>{
  
    switch (mode) {
    case 1:
      return "CASH";
    case 2:
      return "CHEQUE";
    case 3:
      return "ONLINE";
    default:
      return "";
  }
}

// export const NumberDecimalEntry = (value,uptoNumber = 7, uptoDecimal = 2) => {
//   const numberPart = `(0|[1-9]\\d{0,${uptoNumber - 1}})`; // subtract 1 since first digit is already included
//   const decimalPart = uptoDecimal > 0 ? `(\\.\\d{1,${uptoDecimal}})?` : ""; // optional decimal
//   const pattern = `^-?${numberPart}${decimalPart}$`;
//   return new RegExp(pattern);
// };

export const NumberDecimalEntry = (value, uptoNumber = 7, uptoDecimal = 2) => {
  const numberPart = `(?:0|[1-9]\\d{0,${uptoNumber - 1}})`;
  const decimalPart = uptoDecimal > 0 ? `(\\.\\d{0,${uptoDecimal}})?` : "";
  const pattern = `^-?${numberPart}${decimalPart}$`;
  const regex = new RegExp(pattern);
  return regex.test(value);
};

export const OnlyNumberEntry = (value, maxLength = 6) => {
  const pattern = `^[0-9]{1,${maxLength}}$`;
  const regex = new RegExp(pattern);
  return regex.test(value);
};

// OP_OUSTSTANDING_LOAN_MONTHS  
// OP_OUTSTANDING_ADVANCE  
// OP_OUTSTANDING_ADVANCE_DATE  
// OP_OUTSTANDING_LOANS  
// OP_OUTSTANDING_LOAN_DATE  